import { Z_INDEX_LAYERS, Z_INDEX_STEP } from "~/constants/z_index"
import { DialogDOMUtils } from './dom_utils'

// Manages the global dialog stack and layering
export class DialogStackManager {
  constructor() {
    this.stack = (window.__dialogStack ||= [])
  }

  push(el) {
    if (el && !this.includes(el)) this.stack.push(el)
  }

  remove(el) {
    const idx = this.stack.indexOf(el)
    if (idx !== -1) this.stack.splice(idx, 1)
  }

  top() {
    return this.stack[this.stack.length - 1]
  }

  includes(el) {
    return this.stack.includes(el)
  }

  length() {
    return this.stack.length
  }

  // Remove dialogs that are no longer in DOM or are marked closed
  cleanupStale({ isClosedFn, onDisablePointerEvents } = {}) {
    for (let i = this.stack.length - 1; i >= 0; i--) {
      const el = this.stack[i]
      const shouldRemove = !document.contains(el) || (isClosedFn && isClosedFn(el))
      if (shouldRemove) {
        try { onDisablePointerEvents && onDisablePointerEvents(el) } catch (_) {}
        this.stack.splice(i, 1)
      }
    }
  }

  // Apply layering styles across the current stack using provided styling callbacks
  // styleBackdrop(backdrop, layerIndex, index, isTop)
  // stylePanel(panel, layerIndex, isTop)
  // styleOtherFixedNodes(fixedNodes, backdrop, panel, isTop)
  applyLayering({ styleBackdrop, stylePanel, styleOtherFixedNodes } = {}) {
    this.stack.forEach((dialogEl, index) => {
      const layerIndex = index + 1
      const isTop = index === this.stack.length - 1

      const { backdrop, panel, fixedNodes } = DialogDOMUtils.getDialogStructure(dialogEl)

      try { styleBackdrop && styleBackdrop(backdrop, layerIndex, index, isTop) } catch (_) {}
      try { stylePanel && stylePanel(panel, layerIndex, isTop) } catch (_) {}
      try { styleOtherFixedNodes && styleOtherFixedNodes(fixedNodes, backdrop, panel, isTop) } catch (_) {}

      try { dialogEl.style.pointerEvents = isTop ? 'auto' : 'none' } catch (_) {}
    })
  }
}

